import type { ReactElement } from "react"

import { IllustratedState } from "../../../../components/IllustratedState"
import { ShieldIllustration } from "./-Shield"

export const Loading = (): ReactElement => {
  return (
    <IllustratedState
      title="Raising the shield"
      description="Collecting every error the frontend reported in this period"
    >
      <ShieldIllustration />
    </IllustratedState>
  )
}
